import styled, { css } from "styled-components";

export const Grid = styled.div`
    display: grid;
    z-index: 10;
`;

export const Title = styled.h1`
    font-weight: 700;
    font-size: 9vw;
    color: #082e99;
    max-width: 80%;
    margin-top: 5vh;
    margin-left: auto;
    margin-right: auto;
`;

export const TitleBlue = styled.span`
    color: #2770d8;
`;
export const TitleOrange = styled.span`
    color: #e38146;
`;

export const Excerpt = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 1.8vw;
    line-height: 130%;
    text-align: center;
    max-width: 50%;
    color: #082e99;
    margin-top: 36px;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: 1240px) {
        max-width: 80%;
        font-size: calc(90vw * 0.06);
    }
`;

export const WideArticleItem = styled.a`
    //height: 100px;
    margin-left: 10%;
    margin-right: 10%;
    background-color: #082e99;
    border-radius: 40px;
    margin-bottom: 42px;
`;

export const WideArticleText = styled.div`
    margin: 30px;
    font-weight: 600;
    color: #ffffff;
    font-weight: 600;
    font-size: calc(((40vw - 24px) * 0.6) / 10); // card-height / 8
    line-height: 125%;
`;

export const ArticleGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 42px;
    margin-left: 10%;
    margin-right: 10%;
    margin-bottom: 10vh;

    @media (max-width: 1024px) {
        grid-template-columns: 1fr;
    }
`;

export const ArticleItem = styled.a`
    background: url(${(props: { imagePath?: string }) =>
        props.imagePath || "/articles/title-backplate.png"});
    background-blend-mode: darken;
    height: calc((40vw - 24px) * 0.6); // width * 0.6
    border-radius: calc(40vw * 0.06); // width * 0.06
    background-size: cover; /* <------ */
    display: flex;
    text-decoration: none;
    @media (max-width: 1240px) {
        border-radius: calc(90vw * 0.06); // width * 0.06
        height: calc(90vw * 0.6); // width * 0.6
    }
`;

export const ArticleItemText = styled.div`
    font-weight: 600;
    font-size: calc(((40vw - 24px) * 0.6) / 10); // card-height / 8
    line-height: 125%;
    color: ${(props: { color?: string }) => props.color || "white"};
    align-self: flex-end;
    margin-left: calc((40vw * 0.06) * 1.2); // border-radius + 20%
    margin-right: calc((40vw * 0.06) * 3); // border-radius + 20%
    margin-bottom: calc(40vw * 0.06); // border-radius

    @media (max-width: 1240px) {
        font-size: calc(90vw * 0.06);
    }
`;

export const Square = styled.div`
    position: absolute;
    top: 10vw;
    left: 10vw;
    width: 200px;
    height: 200px;
    transform: rotate(-30deg);
    background-color: #eed2b1;
    opacity: 0.3;
    z-index: -1;
    @media (max-width: 1240px) {
        display: none;
    }
`;

export const Arrows = styled.div`
    position: absolute;
    top: 20vw;
    right: 5vw;
    height: 167px;
    width: 276px;
    display: flex;
    align-items: center;
    justify-content: start;
    transform: rotate(-30deg);
    @media (max-width: 1240px) {
        display: none;
    }
`;

export const Arrow = styled.div`
    width: 0;
    height: 0;
    border-style: solid;
    opacity: 0.3;
    border-width: 70px 0 70px 70px;
    border-color: transparent transparent transparent #edd2b1;
`;

export const Share = styled.div`
    display: grid;
    justify-content: center;
    grid-auto-flow: row;
    margin-top: 30px;
    margin-bottom: 50px;
`;

export const ShareSocialList = styled.div`
    padding-top: 20px;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 42px;
    justify-content: flex-start;
    a {
        display: block;
        position: relative;
        cursor: pointer;
        background-size: 32px 32px;
        background-repeat: no-repeat !important;
        width: 60px;
        height: 60px;
        background-position: center;
        &:before {
            content: "";
            display: block;
            position: absolute;
            z-index: -1;
            background: #efd2af;
            border-radius: 50px;
            width: 60px;
            height: 60px;
        }
    }
`;

export const Facebook = styled.a`
    background-image: url(/articles/facebook.svg);
`;

export const LinkedIn = styled.a`
    background-image: url(/articles/linkedin.svg);
`;

export const Telegram = styled.a`
    background-image: url(/articles/telegram.svg);
`;
